module.exports = __webpack_public_path__ + "img/615.Broken_abinet.6ef8bdda.svg";